import { connect } from 'react-redux'
import { push } from 'connected-react-router'

import { AppState } from '../reducers'
import Menu from '../components/Menu'
import * as selectors from '../selectors'
import * as actions from '../actions'

const mapStateToProps = (state: AppState) => ({
	assistantIsRequested: selectors.getAssistantIsRequested(state),
	assistantIsCalled: selectors.getAssistantIsCalled(state),
	isScanning: selectors.getIsScanning(state),
	locale: selectors.getLocale(state),
	isFetchingBarcodeResult: selectors.getIsFetchingBarcodeResult(state),
})

const mapDispatchToProps = {
	sendCallAssistant: actions.sendCallAssistant as any,
	startScanning: actions.startScanning,
	stopScanning: actions.stopScanning,
	setLocale: actions.setLocale,
	detectBarcode: actions.detectBarcode as any,
	push,
}

const ConnectedMenu = connect(mapStateToProps, mapDispatchToProps)(Menu)

export type MenuProps = ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps

export default ConnectedMenu
